<template>
  <div class="testScoreManag">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input
          v-model.trim="query.query"
          placeholder="请输入姓名"
          style="width: 150px"
          @keyup.enter.native="tableLoad"
          @clear="
            query.query = '';
            tableLoad();
          "
          clearable
          suffix-icon="el-icon-search"
        ></el-input>
        <Debounce>
          <el-button style="margin: 0px 10px" size="small" @click="tableLoad">查询</el-button>
        </Debounce>
        <el-select
          v-model="query.subjectId"
          @change="subjectChange"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部考试科目" value=""></el-option>
          <el-option
            v-for="item in subjectList"
            :key="item.subjectId"
            :label="item.subjectName"
            :value="item.subjectId"
          >
          </el-option>
        </el-select>
        <el-select
          style="width: 110px"
          v-model="query.subjectLevel"
          @change="tableLoad"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部等级" value=""></el-option>
          <el-option v-for="item in lvList" :key="item.id" :label="item.lv" :value="item.id">
          </el-option>
        </el-select>
        <el-select
          v-model="query.provinceId"
          filterable
          @change="proChange"
          placeholder="请选择"
          style="width: 110px"
        >
          <el-option label="全部省份" value=""></el-option>
          <el-option v-for="item in proList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select
          v-model="query.examSiteId"
          @change="examChange"
          filterable
          placeholder="请选择"
          style="width: 110px"
        >
          <el-option label="全部市代" value=""></el-option>
          <el-option v-for="item in examSitList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select
          v-model="query.registerId"
          style="width: 110px"
          @change="tableLoad"
          filterable
          placeholder="请选择"
        >
          <el-option label="全部考点" value=""></el-option>
          <el-option
            v-for="item in rationSiteList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          style="width: 110px"
          v-model="query.applicationYear"
          @change="yearSelectChange"
          filterable
          placeholder="请选择"
        >
          <!-- <el-option label="全部年份" value=""></el-option> -->
          <el-option
            v-for="item in applicationFilterYearList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div>
          <el-select
            class="multipleSelect"
            v-model="query.kspc"
            @change="deadlineSelectChange"
            placeholder="请选择"
            style="width: 120px"
          >
            <!-- <el-option label="报名批次（全部）" value=""></el-option> -->
            <el-option label="全部批次" value=""></el-option>

            <el-option
              v-for="item in kspcList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </el-col>

      <!-- <FileOperatDropdown
        @reLoad="tableLoad"
        style="margin:0px 10px;"
        :uploadUrl="'/score/importScore'"
        :downloadUrl="'/score/download'"
        :roles="[
          $roleFilter('testScoreManag:download'),
          $roleFilter('testScoreManag:import'),
        ]"
        :butText="['下载模板', '导入成绩']"
      /> -->

      <el-button
        size="small"
        type="danger"
        @click="deleteClick"
        v-if="$roleFilter('testScoreManag:delete')"
        >删除视频</el-button
      >

      <el-button
        size="small"
        type="primary"
        style="margin-left: 10px; margin-right: 10px"
        v-if="$roleFilter('score:updateSocre')"
        @click="operatInfo(4)"
        >修改成绩</el-button
      >
      <!-- <el-button @click="operatInfo(3)" style="margin-right:10px" v-if="$roleFilter('score:update')" size="small" type="primary">
        生成考级证书
      </el-button> -->
      <input
        type="file"
        ref="uploadFile"
        :accept="accept"
        @change="uploadFileChange"
        v-show="1 != 1"
      />
      <el-dropdown @command="importFile">
        <Debounce>
          <el-button @click="operatInfo(1)" :loading="exportLoading" size="medium" type="primary">
            <template v-if="!exportLoading">
              批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </template>
            <template v-else> 导入/导出中... </template>
          </el-button>
        </Debounce>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="4" v-if="$roleFilter('testScoreManag:download')"
            >下载模板</el-dropdown-item
          >
          <el-dropdown-item command="5" v-if="$roleFilter('testScoreManag:import')"
            >导入成绩</el-dropdown-item
          >

          <el-dropdown-item command="1">导出考生信息</el-dropdown-item>
          <el-dropdown-item command="2">导出考级证书</el-dropdown-item>
          <el-dropdown-item command="3">导出评分详情</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-row>
    <el-table
      :data="tableList"
      tooltip-effect="dark"
      border
      ref="elTable"
      style="width: 100%"
      @sort-change="sortChange"
      @filter-change="filterChange"
      :header-cell-style="$store.getters.getTableHeadStyle"
      v-loading="tableIsLoad"
      element-loading-text="加载中"
      :height="tableHeight"
    >
      <el-table-column key="photo" label="考生照片" width="100" align="center">
        <template slot-scope="scope">
          <img
            :src="scope.row.photo"
            style="width: 30px; height: 30px"
            @click="operatInfo(5, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        key="name"
        prop="name"
        label="姓名"
        width="80"
        sortable="custom"
        align="center"
      ></el-table-column>
      <el-table-column
        key="surName"
        prop="surName"
        label="姓氏拼音"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        key="namePinYin"
        prop="namePinYin"
        label="名字拼音"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column key="sex" width="50" label="性别" align="center">
        <template slot-scope="scope">
          {{ scope.row.sex === 1 ? '男' : '女' }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="age" label="年龄" width="50" align="center"></el-table-column> -->
      <el-table-column
        key="birth"
        prop="birth"
        label="出生日期"
        width="100"
        align="center"
      ></el-table-column>
      <!-- <el-table-column prop="countryName" label="国籍" width="50" align="center"></el-table-column> -->
      <el-table-column
        key="idNumber"
        prop="idNumber"
        label="证件号码"
        width="170"
        align="center"
        sortable="custom"
      ></el-table-column>
      <el-table-column
        key="mobile"
        prop="mobile"
        label="联系电话"
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column
        key="provinceName"
        prop="provinceName"
        label="报考省份"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        key="registerName"
        prop="examSiteName"
        label="市级代理"
        align="center"
        width="100"
      ></el-table-column>
      <el-table-column
        key="examSiteName"
        prop="registerName"
        label="考点"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column prop="kspc" label="考试批次" align="center">
        <template slot-scope="scope">
          {{
            scope.row.kspc === 1
              ? '春季'
              : scope.row.kspc === 2
              ? '夏季'
              : scope.row.kspc === 3
              ? '秋季'
              : scope.row.kspc === 4
              ? '冬季'
              : ''
          }}
        </template>
      </el-table-column>
      <el-table-column
        key="subjectName"
        prop="subjectName"
        label="考试科目"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column key="subjectLevel" label="报考等级" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.subjectLevel | getLvTextByLv }}
        </template>
      </el-table-column>
      <el-table-column
        key="zdjsxm"
        prop="zdjsxm"
        label="指导教师"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        key="zdjsdh"
        prop="zdjsdh"
        label="指导教师电话"
        width="110"
        align="center"
      ></el-table-column>
      <el-table-column
        key="score"
        prop="score"
        label="成绩分数"
        width="120"
        align="center"
        sortable="custom"
      >
        <template slot-scope="{ row }">
          <span
            v-if="
              row.queryState == 1 ||
              $store.state.user.user.userName == 'admin' ||
              $store.state.user.user.roleIdList.findIndex((item) => item == 1) !== -1
            "
            >{{ row.score }}</span
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        key="whetherPass"
        prop="whetherPass"
        label="成绩等级"
        align="center"
        width="100"
        column-key="whetherPass"
        :filter-multiple="false"
        filter-placement="bottom-end"
        :filters="[
          { text: '合格', value: 1 },
          { text: '不合格', value: 2 },
          { text: '优秀', value: 3 },
          { text: '空', value: 0 },
        ]"
      >
        <template slot-scope="{ row }">
          <span
            v-if="
              row.queryState == 1 ||
              $store.state.user.user.userName == 'admin' ||
              $store.state.user.user.roleIdList.findIndex((item) => item == 1) !== -1
            "
            :style="{
              color: getTextAndColor(row.whetherPass).color,
            }"
            >{{ getTextAndColor(row.whetherPass).text }}</span
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column key="lv" label="考级证书" align="center">
        <template slot-scope="{ row }">
          <el-button
            v-if="
              row.queryState == 1 ||
              $store.state.user.user.userName == 'admin' ||
              $store.state.user.user.roleIdList.findIndex((item) => item == 1) !== -1
            "
            type="text"
            size="small"
            :disabled="row.whetherPass == 0 || row.whetherPass == 2 || row.fzTime == null"
            @click="operatInfo(2, row)"
            >考级证书</el-button
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      custom-class="dailogComponents"
      :title="visibleType == 1 ? '考生信息' : visibleType == 3 ? '生成考级证书' : '修改成绩'"
      :visible.sync="visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      v-if="visible"
      :width="visibleType == 1 ? '400px' : visibleType == 3 ? '400px' : '700px'"
    >
      <div v-if="visibleType == 3" class="dialogBox" style="padding-left: 20px">
        证书发放时间:
        <el-date-picker
          size="small"
          v-model="times"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
        <el-row type="flex" style="margin-top: 20px" class="dailogButBox" justify="center">
          <el-button size="medium" @click="visible = false">取消</el-button>
          <el-button size="medium" type="primary" @click="submit">确认</el-button>
        </el-row>
      </div>
      <div class="dialogBox">
        <updateExamInfo @reLoad="reLoad" v-if="visibleType == 4" />
        <div v-if="visibleType == 1">
          <el-row type="flex" class="dialogTitle" justify="space-between">
            <el-col :span="10">
              <p>是否导出照片:</p>
            </el-col>
            <el-col :offset="1">
              <el-radio-group v-model="query.exportPhoto">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row type="flex" class="dialogTitle" justify="space-between">
            <el-col :span="10">
              <p>成绩等级：</p>
            </el-col>
            <el-col :offset="1">
              <el-select v-model="query.exportPass" filterable>
                <el-option label="全部" value=""></el-option>
                <el-option label="合格" value="1"></el-option>
                <el-option label="不合格" value="2"></el-option>
                <el-option label="优秀" value="3"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row type="flex" style="margin-top: 20px" class="dailogButBox" justify="center">
            <el-button size="medium" @click="visible = false">取消</el-button>
            <el-button
              size="medium"
              type="primary"
              :loading="exportStuLoading"
              @click="exprotStudentInfo"
              >确认</el-button
            >
          </el-row>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="删除视频"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        请选择考试年份：
        <el-select v-model="nf" filterable placeholder="请选择">
          <el-option
            v-for="item in filteredArray"
            :key="item.value"
            :label="item.label + '年'"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div style="color: red; margin-top: 20px; margin-bottom: 10px">
        温馨提醒：该操作将彻底删除考生上传的视频，请谨慎操作
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="videoDelete">删 除</el-button>
      </div>
    </el-dialog>
    <Pagination
      :total="query.total"
      :page.sync="query.pageNum"
      :limit.sync="query.pageSize"
      class="pagination-content"
      @pagination="tableLoad"
    />
  </div>
</template>

<script>
import { exportFile } from '@/uitls/globalFun.js';
import updateExamInfo from './updateExamInfo';
import FileOperatDropdown from '@/views/admin/components/FileOperatDropdown';

export default {
  async created() {
    await this.getApplicationFilterYearSelect();
    // await this.getDeadlineSelect();
    this.getSelectList();
    this.tableLoad();
  },
  components: {
    updateExamInfo,
    FileOperatDropdown,
  },
  data() {
    return {
      tableList: [],
      dialogVisible: false,
      passRateList: [],
      proList: [], //省份考点下拉菜单
      applicationFilterYearList: [], //年份过滤框
      // yearList: [], //年份过滤框
      filteredArray: [], //年份过滤框
      examSitList: [], //考点下拉菜单
      subjectList: [],
      lvList: [
        { id: 1, lv: '一级' },
        { id: 2, lv: '二级' },
        { id: 3, lv: '三级' },
        { id: 4, lv: '四级' },
        { id: 5, lv: '五级' },
        { id: 6, lv: '六级' },
        { id: 7, lv: '七级' },
        { id: 8, lv: '八级' },
        { id: 9, lv: '九级' },
        { id: 10, lv: '十级' },
        { id: 11, lv: '初级' },
        { id: 12, lv: '中级' },
        { id: 13, lv: '高级' },
      ], //报考等级下拉
      rationSiteList: [], //报名点下拉框
      deadlineSelect: [], //批次
      tableIsLoad: true,
      visible: false,
      exportStuLoading: false, //导出考生信息
      visibleType: 0, //删除
      times: '',
      query: {
        query: '',
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        provinceId: '', //省份Id
        examSiteId: '', //考点ID
        registerId: '', //报名点ID
        subjectId: '', //考试科目ID
        subjectLevel: '', //报考等级ID
        exportPhoto: 1, //是否导出照片
        exportPass: '', //是否合格
        kspc: '', //批次
        applicationYear: '', //考试年份
        orderByChineseMethod: null, //姓名排序
        orderByChineseField: null, //姓名排序
        // deadLine: [""], //批次
      },
      exportLoading: false,
      tableHeight: null,
      nf: '',
      kspcList: [
        { value: '1', label: '春季' },
        { value: '2', label: '夏季' },
        { value: '3', label: '秋季' },
        { value: '4', label: '冬季' },
      ],
      accept: '.xls,.xlsx',
    };
  },
  methods: {
    deadlineSelectChange(val) {
      //如果存在空字符串
      // if (val.some((item) => !item)) {
      //   this.query.deadLine = [""];
      // } else {
      //   this.query.deadLine = val;
      // }
      this.tableLoad();
    },
    yearSelectChange() {
      // this.query.deadLine = [""];
      // this.getDeadlineSelect();
      this.tableLoad();
    },
    getTextAndColor(val) {
      let text = ['', '合格', '不合格', '优秀'][val],
        color = ['', '#66CC66', '#f56c6c', '#409eff'][val];
      return {
        text,
        color,
      };
    },
    //列表排序改变事件
    sortChange(column) {
      if (column != null && column.order != null) {
        this.query.orderByMethod = column.order === 'ascending' ? 'asc' : 'desc';
        this.query.orderByField = column.prop === 'idNumber' ? 'id_number' : column.prop;
        //排序字段为名字
        console.log(column);
        if (column.prop === 'name') {
          this.query.orderByMethod = null;
          this.query.orderByField = null;
          this.query.orderByChineseMethod =
            column.order === 'ascending'
              ? 'asc'
              : column.order === 'ascending'
              ? 'descending'
              : 'desc';
          this.query.orderByChineseField = column.prop;
        } else {
          this.query.orderByChineseMethod = null;
          this.query.orderByChineseField = null;
        }
      } else {
        this.query.orderByMethod = null;
        this.query.orderByField = null;
        this.query.orderByChineseMethod = null;
        this.query.orderByChineseField = null;
      }
      this.tableLoad();
    },
    //过滤事件
    filterChange(filters) {
      if (filters != null) {
        this.query.whetherPass = filters.whetherPass.length > 0 ? filters.whetherPass[0] : null;
      }
      this.tableLoad();
    },
    //获取考试年份过滤下拉
    async getApplicationFilterYearSelect() {
      await this.$axios.get('/examInformation/selectFilterData').then((rs) => {
        let appYears = rs.data.data;
        this.applicationFilterYearList = appYears;
        this.query.applicationYear = appYears[0].label;
        this.nf = appYears[appYears.length - 1].label;
        // 获取当前年份
        const currentYear = new Date().getFullYear();

        // 使用 filter 方法删除当前年份及之后的所有对象
        const filteredArray = appYears.filter((year) => parseInt(year.value, 10) < currentYear);
        this.filteredArray = filteredArray;
        // 输出结果
        this.tableLoad();
      });
      // await this.$axios.get("/apply/yearLine").then((rs) => {
      //   let appYears = rs.data.data;
      //   console.log(appYears);
      //   this.yearList = appYears;
      //   this.query.applicationYear = appYears[0].parentId;
      // });
    },
    // 初始化表格
    tableLoad() {
      this.tableIsLoad = true;
      this.$axios.post('/score', this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list.map((item) => {
          if (item.score === 0) {
            item.score = '';
          }
          return item;
        });
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    videoDelete() {
      if (this.nf === '') {
        this.$message.error('请先选择年份');
        return;
      }
      // console.log(this.nf);
      this.$axios.get(`/video/delete/${this.nf}`).then((res) => {
        this.$message.success('操作成功');
        this.dialogVisible = false;
      });
    },
    // 全部下拉菜单
    getSelectList() {
      this.$axios.get('/score/newProvince').then((res) => {
        let data = res.data.data;
        this.proList = data;
      });
      this.$axios.get('/score/examinationSite').then((res) => {
        let data = res.data.data;
        this.examSitList = data;
      });
      this.$axios.get('/score/rationSite').then((res) => {
        let data = res.data.data;
        this.rationSiteList = data;
      });
      this.$axios.get('/score/level').then((res) => {
        let data = res.data.data;
        this.subjectList = data;
      });
    },
    // async getDeadlineSelect() {
    //   await this.$axios
    //     .get("/score/getDeadlineSelect?appYear=" + this.query.applicationYear)
    //     .then((res) => {
    //       let data = res.data.data;
    //       this.deadlineSelect = data;
    //     });
    // },
    operatInfo(type, row) {
      this.visibleType = type;
      // 导出
      if (type === 1) {
      } else if (type === 2) {
        window.open(`/api/score/lookNoback/${row.id}`);
      } else if (type == 3) {
        // 生成考试合格证书
        this.visible = true;
      } else if (type == 4) {
        // 修改成绩
        this.visible = true;
      } else if (type == 5) {
        this.$alert(`<img src="${row.photo}" style="width:100%;max-height:700px;" />`, '图片查看', {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          closeOnClickModal: true,
        });
      }
    },
    deleteClick() {
      this.nf = this.filteredArray[this.filteredArray.length - 1].label;
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
      this.nf = '';
    },
    proChange(val) {
      // this.query.examSiteId = "";
      // if (val == "") {
      //   this.examSitList = [];
      // } else {
      //   let proObj = this.proList.find((item) => {
      //     return item.value === val;
      //   });
      //   this.examSitList = proObj.children;
      // }
      this.tableLoad();
    },
    //考点切换事件
    examChange(value) {
      // this.query.registerId = "";
      // if (value == "") {
      //   this.rationSiteList = [];
      // } else {
      //   let proObj = this.examSitList.find((item) => {
      //     return item.value === value;
      //   });
      //   this.rationSiteList = proObj.children;
      // }
      this.tableLoad();
    },
    subjectChange(val) {
      // this.query.subjectLevel = "";
      // if (val == "") {
      //   this.lvList = [];
      // } else {
      //   let lvList = this.subjectList.find((item) => {
      //     return item.subjectId == val;
      //   });
      //   this.lvList = lvList.examLevelVOS;
      // }
      this.tableLoad();
    },
    //导出考生信息
    exprotStudentInfo() {
      this.exportStuLoading = true;
      let {
        exportPhoto,
        exportPass,
        pageNum,
        pageSize,
        applicationYear,
        kspc,
        // deadLine,
      } = this.query;
      this.$axios
        .post(
          '/score/exportExaminee',
          {
            exportPhoto,
            pageSize,
            pageNum,
            applicationYear,
            kspc,
            whetherPass: exportPass,
          },
          { responseType: 'blob' }
        )
        .then((res) => {
          exportFile(res);
          this.exportStuLoading = false;
          this.visible = false;
        });
    },

    operation(command) {
      if (command == 'download') {
        //  下载导入模板
        this.$axios
          .get('/score/download', {
            responseType: 'blob',
          })
          .then((res) => {
            exportFile(res);
          });
      }
    },
    // 导入按钮事件
    handleUpload(res) {
      if (res.code == 200 && res.message) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.tableLoad();
    },
    // 导入出错
    handleError(err) {
      console.log(err);
      this.$message.error('导入失败，请重试');
    },
    importFile(type) {
      if (type == 1) {
        this.visibleType = 1;
        this.query.exportPhoto = 1;
        this.query.exportPass = '';
        //导出考生信息
        this.visible = true;
      }
      // 考级证书
      else if (type == 2) {
        this.exportLoading = true;
        this.$axios.post('/score/export', this.query, { responseType: 'blob' }).then((res) => {
          exportFile(res);
          this.exportLoading = false;
        });
      }
      //评分详情
      else if (type == 3) {
        this.$axios.post('/score/exportScore', this.query, { responseType: 'blob' }).then((res) => {
          exportFile(res);
        });
      } else if (type == 4) {
        this.$axios
          .get('/score/download', {
            responseType: 'blob',
          })
          .then((res) => {
            exportFile(res);
          });
      } else if (type == 5) {
        this.$refs.uploadFile.click();
      }
    },
    uploadFileChange(e) {
      const loading = this.$loading({
        lock: true,
        text: '正在导入',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append('file', file);
      e.outerHTML = e.outerHTML; //可清空当前file之前添加的文件
      e.target.value = '';
      this.$axios
        .post('/score/importScore', formData)
        .then((res) => {
          this.$message({
            type: 'success',
            message: '导入成功！',
            duration: 1000,
          });
          loading.close();
          this.visible = false;
          this.tableLoad();
        })
        .catch((err) => {
          loading.close();
          this.visible = false;
          this.tableLoad();
        });
    },
    submit() {
      if (this.times == '') {
        this.$message({
          type: 'warning',
          message: '请填写发放时间!',
          duration: 1000,
        });
        return;
      }
      this.$axios.get('/score/update/' + this.times).then((res) => {
        this.$message({
          type: 'success',
          message: '生成考级证书成功!',
          duration: 1000,
        });
        this.times = '';
        this.visible = false;
        this.tableLoad();
      });
    },
    reLoad() {
      this.visible = false;
      this.tableLoad();
    },
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 220;
    window.onresize = () => {
      return (() => {
        this.tableHeight = document.documentElement.clientHeight - 220;
      })();
    };
  },
};
</script>
<style lang="scss" scoped>
.tableHearInputBox {
  .el-select {
    width: 140px;
    margin-right: 10px;
  }

  .multipleSelect {
    width: 240px;
  }
}
</style>
